__turbopack_context__.v({
  "iframeBlock": "IFrameBlock-module__f7nEuG__iframeBlock",
  "iframeContainer": "IFrameBlock-module__f7nEuG__iframeContainer",
});
